import { IValidationProps } from "components/upload/dropzone-uploader";

export class ValidationError extends Error {
    constructor(
        public message: string,
        public key?: keyof IValidationProps | "ratio" | "multiple"
    ) {
        super(message);
    }
}

export default ValidationError;
